module.exports = __webpack_public_path__ + "static/media/Washing Machine.93e34e6c.svg";